import ko from "knockout";

export class FilterModel {
    selectedDepartmentId: KnockoutObservable<string>;
    selectedFunctionId: KnockoutObservable<string>;
    selectedEventId: KnockoutObservable<string>;
    openShiftsOnly: KnockoutObservable<boolean>;

    constructor() {
        this.selectedDepartmentId = ko.observable<string>('');
        this.selectedFunctionId = ko.observable<string>('');
        this.selectedEventId = ko.observable<string>('');
        this.openShiftsOnly = ko.observable<boolean>(false);
    }
}
